import React from "react";
import styled from "styled-components";

const Button = styled.button`
  height: 50px;
  width: 150px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.5s ease-in-out;

  &:hover {
    box-shadow: 0.5px 0.5px 150px #252525;
  }

  &::after,
  &::before {
    content: "";
    height: 50px;
    width: 150px;
    background-color: #008080;
    color: #fff;
    position: absolute;
    top: 0%;
    left: 0%;
    font-size: 0.9rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s ease-in-out;
  }

  &::before {
    content: ${({ first }) => `"${first}"`};
    transform: translateY(0px) scale(1.2);
  }

  &::after {
    content: ${({ second }) => `"${second}"`};
    background-color: #008080;
    color: #fff;
    transform: translateY(50px);
  }

  &:hover::after {
    transform: translateY(0) scale(1.2);
  }

  &:hover::before {
    transform: translateY(-50px) scale(0) rotate(120deg);
  }
`;

const ReservePlaceButton = ({ first, second, url }) => {
  return <Button first={first} second={second} />;
};

export default ReservePlaceButton;
